var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 14,
    viewBox: "0 0 109 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22234 1.33247H9.26975L11.8625 8.60634H11.914L12.9271 4.70125L14.1291 1.13135H16.8249V1.50007L12.6867 12.964H11.1585L8.7718 6.62865H8.72028L6.402 12.964H4.8223L0.666992 1.50007V1.13135H3.36279L4.58191 4.718L5.66366 8.60634H5.71518L8.22234 1.33247Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1487 10.9197H21.1522L20.2248 12.8639H17.5464V12.5287L23.0753 1.03125H24.2601L29.7548 12.5287V12.8639H27.0933L26.1487 10.9197ZM23.6589 4.93635L21.9934 8.80793H25.3245L23.6589 4.93635Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.583 3.31016H30.3721V1.13135H39.2665V3.31016H36.0727V12.8634H33.583V3.31016Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6201 1.13135V3.32715H44.8467V5.70708H49.3111V7.90288H44.8467V10.5845H49.7575V12.8639H42.2539V1.13182H49.6201V1.13135Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6092 8.58974L63.3222 12.4948V12.8468H60.5749L58.1023 8.97522H55.956V12.8468H53.3804V1.11475H58.5142C59.8306 1.11475 60.8665 1.50861 61.6221 2.29633C62.3776 3.08429 62.7553 4.031 62.7553 5.13717C62.7553 5.88601 62.5664 6.56782 62.1887 7.18189C61.8112 7.79666 61.2846 8.26571 60.6092 8.58974ZM55.9216 6.91397H58.4975C59.0238 6.91397 59.4531 6.73775 59.785 6.38579C60.117 6.03383 60.277 5.60109 60.2661 5.08688C60.2661 4.58408 60.1056 4.16252 59.785 3.8215C59.4645 3.48071 59.035 3.31032 58.4975 3.31032H55.9216V6.91397Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3844 6.49483V8.69063H69.0745V12.8639H66.5161V1.13184H73.8824V3.32764H69.0745V6.49506H73.3844V6.49483Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6702 10.9197H78.6737L77.7463 12.8639H75.0679V12.5287L80.5968 1.03125H81.7816L87.2762 12.5287V12.8639H84.6148L83.6702 10.9197ZM81.1806 4.93635L79.5151 8.80793H82.8462L81.1806 4.93635Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4438 1.13135V10.6176H97.4576V12.8634H89.8682V1.13135H92.4438Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.986 1.13135V10.6176H108V12.8634H100.411V1.13135H102.986Z",
    fill: "#EDEDED",
    stroke: "#EDEDED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLogo);
export default __webpack_public_path__ + "static/media/TextLogo.885e1402.svg";
export { ForwardRef as ReactComponent };